<template>
    <div class="right-part mail-list bg-white">
        <div class="p-15 b-b">
            <div class="d-flex align-items-center">
                <div>
                    <h4>Mailbox </h4>
                    <span>Here is the list of mail(s)</span>
                </div>
            </div>
        </div>
        <div class="bg-light p-15 d-flex align-items-center do-block">
            <div class="btn-group m-t-5 m-b-5">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input sl-all" :disabled="inbox.length == 0" id="cstall" @click="selectAll" v-model="allChecked">
                    <label class="form-check-label" for="cstall">Check All</label>
                </div>
            </div>
            <div class="ml-auto">
                <div class="btn-group m-r-10" role="group" aria-label="Button group with nested dropdown">
                    <button type="button" class="btn btn-outline-secondary font-18" @click="getInboxMails(1)"><i class="mdi mdi-reload"></i></button>
                    <button type="button" class="btn btn-outline-secondary font-18" @click="deleteMail"><i class="mdi mdi-delete"></i></button>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table email-table no-wrap table-hover v-middle">
                <tbody>
                <tr v-for="(m, index) in inbox" v-bind:key="index">
                    <!-- label -->
                    <td class="chb">
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" :id="'mail'+m.id" v-model="mailids" :value="m.id" @click="select(m.id)">
                            <label class="form-check-label" :for="'mail'+m.id">&nbsp;</label>
                        </div>
                    </td>
                    <!-- User -->
                    <td class="user-image" @click="showMail(m.id)">
                        <blockie v-if="m.sender_email" :address="m.sender_email" :width="30"></blockie>
                    </td>
                    <td class="user-name" @click="showMail(m.id)">
                        <h6 class="m-b-0">{{m.sender_fname}} {{m.sender_lname}}</h6>
                    </td>
                    <!-- Message -->
                    <td class="max-texts" @click="showMail(m.id)">
                        <a class="link" href="javascript: void(0)"><span class="blue-grey-text text-darken-4">{{m.subject}}</span></a>
                    </td>
                    <!-- Attachment -->
                    <td class="clip" @click="showMail(m.id)">
                        <i class="fa fa-paperclip" v-if="m.attachments.length > 0"></i>
                    </td>
                    <!-- Time -->
                    <td class="date-time" @click="showMail(m.id)">{{m.created_at | medium}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="p-15 m-t-30">
            <nav aria-label="Page navigation example">
                <paginate
                        :page-count=pageCount
                        :page-range="3"
                        :margin-pages="2"
                        :click-handler="pageHandler"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :next-class="'page-link'"
                        :container-class="'pagination float-right'"
                        :page-class="'page-link'">
                </paginate>
            </nav>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Paginate from 'vuejs-paginate';
    import Blockie from "../common/Blockie";

    export default {
        name: "Inbox",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Paginate, Blockie},
        data() {
            return {
                mailid: '',
                inbox: [],
                pageCount: 1,
                total: 0,
                allChecked: false,
                mailids: []
            };
        },
        mounted() {
            this.getInboxMails(1);
        },
        methods: {
            selectAll() {
                if(this.mailids.length === this.inbox.length) {
                    this.mailids = [];
                } else {
                    this.mailids = [];
                    this.mailids = this.inbox.map(mail => mail.id);
                }
                this.isAllchecked();
            },
            isAllchecked() {
                this.allChecked = (this.mailids.length > 0) && (this.mailids.length === this.inbox.length);
            },
            select(id) {
                if(this.mailids.includes(id)) {
                    this.mailids.splice(this.mailids.indexOf(id), 1);
                } else {
                    this.mailids.push(id);
                }
                this.isAllchecked();
            },
            showMail(mailid) {
                this.$router.push({name: "mail", params: {mailid: mailid}});
            },
            getInboxMails(page) {
                this.$http
                .get("/mailbox/inbox", {
                    params: {
                        page: page,
                        perPage: 10
                    }
                })
                .then(reply => {
                    this.total = reply.data.total;
                    this.inbox = reply.data.mails;
                    this.setPageCount();
                })
                .catch(err => {
                    console.error(err);
                })
            },
            pageHandler(pageNum) {
                this.getInboxMails(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10);
            },
            async deleteMail() {
                if(this.mailids.length > 0) {
                    await this.$http.delete("/mailbox", {data: {mailids: this.mailids}});
                    await this.getInboxMails(1);
                    this.mailids = [];
                    await this.isAllchecked();
                } else {
                    this.$toastr('error', 'Please select a mail to delete.', 'Delete Fail');
                }
            }
        }
    }
</script>

<style scoped>

</style>
